import { render, staticRenderFns } from "./RecStatistic2.vue?vue&type=template&id=5947d514&scoped=true"
import script from "./RecStatistic2.vue?vue&type=script&lang=js"
export * from "./RecStatistic2.vue?vue&type=script&lang=js"
import style0 from "./RecStatistic2.vue?vue&type=style&index=0&id=5947d514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947d514",
  null
  
)

export default component.exports